import CryptoAES from 'crypto-js/aes'
import Cookies from 'js-cookie';

export const getCookie = (name) => {
  var cookieName = name + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(cookieName.length, c.length)
    }
  }
  return null
}
// Get cookie
// export const getCookie = (name) => {
//   const encryptedValue = Cookies.get(name);
//   if (!encryptedValue) return null;

//   try {
//     const bytes = CryptoAES.decrypt(encryptedValue, 'secretKey');
//     return bytes.toString(CryptoENC);
//   } catch (e) {
//     console.error("Failed to decrypt cookie", e);
//     return null;
//   }
// }

// Set cookie
// export const setCookie = (name, value, days = 1) => {
//   const encryptedValue = CryptoAES.encrypt(value, 'secretKey').toString();
//   Cookies.set(name, encryptedValue, { path: "/", expires: days });
// }

export const setCookie = (name, value, days) => {
  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  var encryptedValue = CryptoAES.encrypt(value, 'secretKey')
  document.cookie = name + '=' + encryptedValue + expires + '; path=/'
}

